<div class="ReceiptLookupContent flex-row flex-top">
    <div class="ReceiptLookupContent-container flex-col-8 flex-col-6-md flex-col-12-sm">
        <router-outlet></router-outlet>
    </div>
</div>
